import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { TrialBalanceSection } from '@/features/ledger/trial-balance'

/**
 * The trial balance, as an addressable screen of its own.
 *
 * Read-only, so it works on a phone by policy: reading a figure is not the same as producing one,
 * and an accountant asked a question away from their desk is exactly who this is for. The verdict —
 * whether it balances, on movement and on position — is stated above the rows rather than left to be
 * worked out from them.
 */
export function LedgerTrialBalancePage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Trial balance"
        description="What the book says, for a range and a branch, as at the moment it was produced — and whether it balances, which is the point of producing one."
      />

      <TrialBalanceSection />
    </>
  )
}
